import { ScheduleState } from "../../../type/schedule-state";

export const clearSelectedScheduleDispatch = (state: ScheduleState) => {
  state.selectedSchedule = undefined;
};
